import { useState } from "react";
import {agencyCertificateSelector} from "./util";

export const SimpleEACard = ({ data }) => {
  const [ selectedAgency, setSelectedAgency ] = useState( data.agencies[-1] !== undefined ? -1 : Object.keys( data.agencies ).sort()[0] )

  const earnDate = new Date( parseInt(data.earn_date) * 1000 )
  const year = earnDate.getFullYear();
  const month = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ][ earnDate.getMonth() ]
  const day = earnDate.getDate()

  return (
    <div className="tgbl-user-earned-accreditations__list__item tgbl-ea-card-layout-simple tgbl-card tgbl-card-content tgbl-card--flow-row tgbl-card--is-elevated" >
      <div className="tgbl-card__header tgbl-user-earned-accreditations__list__item__header">
        <div className="tgbl-user-earned-accreditations__list__item__header__details">
          <div className="tgbl-user-earned-accreditations__list__item__header__details__stats tgbl-flex tgbl-flex--wrap tgbl-flex--density-20">
            <span className="tgbl-chip tgbl-chip--style-icon">
              <svg className="tgbl-icon tgbl-icon--calendar-day" width="1em" height="1em" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <g clipPath="url(#a)" fill="currentcolor">
                  <path d="M19 7.8a1.4 1.4 0 0 0-1.4-1.4h-1.4v-.7a.7.7 0 1 0-1.4 0v.7h-2.1v-.7a.7.7 0 0 0-1.4 0v.7H9.2v-.7a.7.7 0 1 0-1.4 0v.7H6.4A1.4 1.4 0 0 0 5 7.8v1.4h14V7.8ZM5 17.6A1.4 1.4 0 0 0 6.4 19h11.2a1.4 1.4 0 0 0 1.4-1.4v-7H5v7ZM8.5 12h7a.7.7 0 1 1 0 1.4h-7a.7.7 0 1 1 0-1.4Z"/>
                </g>
                <defs>
                  <clipPath id="a">
                    <path fill="#fff" transform="translate(5 5)" d="M0 0h14v14H0z"/>
                  </clipPath>
                </defs>
              </svg>
              <span className="tgbl-chip__content">Earned {`${month} ${day}, ${year}`}</span>
            </span>
          </div>
        </div>
      </div>

      <form className="tgbl-card__content tgbl-user-earned-accreditations__list__item__print-form" action={`${window.location.origin}/tgbl-cred-certificates`} target="_blank">
        { agencyCertificateSelector(data.agencies, selectedAgency, setSelectedAgency, '') }
      </form>
    </div>
  )

};
